import { createClient } from './createClient.js';
import { testActions } from './decorators/test.js';
export function createTestClient({ chain, key = 'test', name = 'Test Client', mode, pollingInterval, transport, }) {
    const client = {
        ...createClient({
            chain,
            key,
            name,
            pollingInterval,
            transport,
            type: 'testClient',
        }),
        mode,
    };
    return {
        ...client,
        ...testActions(client),
    };
}
//# sourceMappingURL=createTestClient.js.map